// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Faq_wrapper__2zPc3","question":"Faq_question__TZNgJ"};